import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppsState } from '../reducers/applifecycle.reducer';

export const appsState: any = createFeatureSelector<AppsState>('apps');

export const appsList = createSelector(appsState, (state: any) => {
  return state.data;
});

export const allAppsList = createSelector(appsState, (state: any) => {
  return state.allAppList;
});

export const appDropList = createSelector(appsState, (state: any) => {
  return state.appDropList;
});

export const totalRecords = createSelector(appsState, (state: any) => {
  return state.totalRecords;
});

export const appData = createSelector(appsState, (state: any) => state.sidAppData);

export const appDataWithId = createSelector(appsState, (state: any) => state.appId);

export const appLoader = createSelector(appsState, (state: any) => state.loader);
export const updateStatus = createSelector(appsState, (state: any) => state.updateSuccess);
export const deleteStatus = createSelector(appsState, (state: any) => state.deleteSuccess);
export const selectedAppData = createSelector(appsState, (state: any) => state.selectedAppdata);

export const newlyCreatedApp = createSelector(appsState, (state: any) => state.createdApp);

export const newlyCreatedAppErr = createSelector(appsState, (state: any) => state.errorMessage);

export const searchText = createSelector(appsState, (state: any) => state.searchText);

export const appId = createSelector(appsState, (state: any) => state.appId);

export const appstateData = createSelector(appsState, (state: any) => state);

export const genUrl = createSelector(appsState, (state: any) => state.genUrl);

export const genStatus = createSelector(appsState, (state: any) => state.genStatus);

export const usersBasedOnApp = createSelector(appsState, (state: any) => state.usersBasedOnApp);

export const userSaveStatus = createSelector(appsState, (state: any) => state.userSaveStatus);

export const publishLog = createSelector(appsState, (state: any) => state.publishLog);

export const generationStage = createSelector(appsState, (state: any) => state.generationStage);

export const currentAppFullData = createSelector(appsState, (state: any) => state.currentAppFullData);

export const metaInfo = createSelector(appsState, (state: any) => state.metaInfo);

export const fsLoginInitiated = createSelector(appsState, (state: any) => state.loggedIn);

export const indepApps = createSelector(appsState, (state: any) => {
  return state.indepApps;
});

export const dbList = createSelector(appsState, (state: any) => {
  return state.dbList;
});

export const memAppList = createSelector(appsState, (state: any) => {
  return state.memAppList;
});

export const memtechnologyStackData = createSelector(appsState, (state: any) => {
  return state.memtechnologyStackData;
});

export const memdbList = createSelector(appsState, (state: any) => {
  return state.memdbList;
});

export const allAppFromSuiteList = createSelector(appsState, (state: any) => {
  return state.allAppFromSuiteList;
});

